/**
 * Reducer for the membership overview.
 *
 * Action results and downloads are read from the promises their dispatch
 * returns, so the store keeps neither.
 * @module reducers/membership
 */

import type { MembershipOverview } from '../types';
import { requestReducer } from './factory';
import { IDP_GET_MEMBERSHIP } from '../constants/ActionTypes';

/** The overview before anything has loaded. */
export const emptyOverview: MembershipOverview = {
  '@id': '',
  renewal_cycle_open: false,
  stats: {
    total_members: 0,
    total_countries: 0,
    states: [],
    countries: [],
    years: [],
  },
  downloads: [],
  actions: [],
};

/** `GET @membership`: member counts, downloads and renewal cycle steps. */
export const membership = requestReducer(
  IDP_GET_MEMBERSHIP,
  (result: MembershipOverview) => result,
  emptyOverview,
);
